// extracted by mini-css-extract-plugin
module.exports = {"container":"competitors_container__13_Ew","list":"competitors_list__2AHQ9"};